import { Route } from "react-router-dom";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Features, Roles } from "../../components/routing/utils";
import ManageLocations from "../../modules/manage-locations/ManageLocations";

// import Maris from "./page.highorder";

const ManageLocationsRouteComponent = () => {
  return (
    <AuthorizedRoute
    //   requiredRoles={[Roles.ADMIN]}
      component={ManageLocations}
      //   requiredFeatures={[Features.MANAGE_MARIS]}
    />
  );
};

const manageLocationsRoute = (
  <Route path="/manage-locations" element={<ManageLocationsRouteComponent />} />
);

export default manageLocationsRoute;
